module.exports = __webpack_public_path__ + "img/hero-visual.416d7de9.png";